// Copyright (c) 2019 Deere & Company

import './success-alert-bar.scss';
import { AlertBarBase } from './alert-bar-base';
import PropTypes from 'prop-types';
import React from 'react';

export const SuccessAlertBar = ({
    alertTitle, canDismiss, dismissHandler,
    timeoutLength, willAutoDismiss, children,
}) => (
    <div className="success-alert-bar">
        <AlertBarBase
            alertTitle={alertTitle}
            canDismiss={canDismiss}
            dismissHandler={dismissHandler}
            iconClass="icon-checkmark"
            timeoutLength={timeoutLength}
            willAutoDismiss={willAutoDismiss}
        >
            {children}
        </AlertBarBase>
    </div>
);

SuccessAlertBar.propTypes = {
    alertTitle: PropTypes.any.isRequired,
    canDismiss: PropTypes.bool,
    timeoutLength: PropTypes.number,
    willAutoDismiss: PropTypes.bool,
    dismissHandler: PropTypes.any,
    children: PropTypes.any,
};

SuccessAlertBar.defaultProps = {
    canDismiss: true,
    willAutoDismiss: true,
};
